import BodyTextMedium from "./BodyTextMedium";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import HeadingSmall from "./HeadingSmall";
import JumpToSection from "./JumpToSection";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TwoColBox from "./TwoColBox";

function AboutUs({ callout, text }) {
  return (
    <Box bg="black" pb={[90, null, 150, null]}>
      <BoxWithGutter>
        <TwoColBox
          col1={<HeadingSmall color="white">{callout}</HeadingSmall>}
          col2={
            <>
              <RichTextLarge color="white">{text}</RichTextLarge>
              <Box>
                <JumpToSection sectionName="Re-sale" sectionId="about-resale" />
                <JumpToSection
                  sectionName="Re-purpose"
                  sectionId="about-repurpose"
                />
                <JumpToSection
                  sectionName="Re-cycle"
                  sectionId="about-recycle"
                />
              </Box>
            </>
          }
        ></TwoColBox>
      </BoxWithGutter>
    </Box>
  );
}

export default AboutUs;

AboutUs.propTypes = {
  callout: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
